import serializable from "../common/decorators/serializable";
import { EntityFirebase } from "../common/entity.firebase";

@serializable
export class CustomerAccount extends EntityFirebase {
  constructor(
    public readonly id: string,
    private customerId: string,
    private balance: number = 0
  ) {
    super();
  }

  getCustomerId() {
    return this.customerId;
  }

  getBalance() {
    return this.balance;
  }

  setBalance(balance: number) {
    this.balance = Math.max(0, balance);
  }

  static async build(id: string, data: any) {
    return new this(
      id,
      data.customerId || id,
      typeof data.balance === "number" ? data.balance : 0
    );
  }
}
